export const useIsEmbedded = () => {
    try {
        return window.self !== window.top;
        // eslint-disable-next-line no-unused-vars
    } catch (e) {
        return true;
    }
};
